define.alias("shared/components/shared/ui/mobile-menu", "calendar/components/shared/ui/mobile-menu");